export enum ErrorMessageType {
  Required = 'required to Save',
  RequiredToSubmit = 'required'
}
